import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import SideNav from "../Sidenav";
import icon from "../../assets/images/tooltipaccountsetup.svg";
import { setReturnPath } from "../../StateManagement/Reducers/AccountSetupState";
import { Button, Col, Form, Modal } from "react-bootstrap";
import axiosInstance from "../../axios/axios";
import {
  Decrypt_Value,
  Encrypt_Value,
} from "./../../MiddleWare/EncryptDecrypt";
import { BsCheckCircle } from "react-icons/bs";
import BlueTick from "../../assets/images/bluetick.png";
import Loader from "../popups/Loading";

const AccountSetup = () => {
  var user_ID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  const provname = localStorage.getItem("provider_name")
    ? Decrypt_Value(localStorage.getItem("provider_name"), "vozo")
    : "";
  const history = useHistory();
  const dispatch = useDispatch();
  const [navData1, setNavData1] = useState("iconopen");
  const [progress, setProgress] = useState(35);
  const [modelPopup, setModelPopup] = useState(false);
  const [is_sub_but_dis, setIs_sub_but_dis] = useState(false);
  const [modalAlerShow1, setModalAlerShow1] = useState(false);
  const [errMsg, setErrMsg] = useState({
    name: false,
    email: false,
    msg: false,
  });
  const [form, setForm] = useState({
    name: provname,
    email: "",
    msg: "",
  });

  const [demoEnabled, setDemoEnabled] = useState(false);
  const [demoLoading, setDemoLoading] = useState(false);
  const [showDemoModal, setShowDemoModal] = useState(false);
  const NavData1 = useSelector((state) => state.Schedule?.NavData);
  const [completedSteps, setCompletedSteps] = useState([]);
  const storedNames = Decrypt_Value(localStorage.getItem("setroles"), "vozo");

  // Get user ID directly in the callback rather than using memo
  const getUserId = () => {
    const userId = localStorage.getItem("user_id");
    return userId ? Decrypt_Value(userId, "vozo") : null;
  };

  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrMsg((prev) => ({ ...prev, [name]: false }));
  };

  const insuranceCoveragePath = storedNames.demo
    ? "/patient/insuranceCoverage/1"
    : "/patient/patientlist";

  const patientLocationPath1 = storedNames.demo
    ? "/patient/demographics/1"
    : "/patient/patientlist";

  const patientLocationPath2 = storedNames.demo
    ? "/patient/billandinsurance/1"
    : "/patient/patientlist";

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErr = {
      name: !form.name.trim(),
      email: !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email),
      msg: !form.msg.trim(),
    };

    setErrMsg(newErr);
    const hasError = Object.values(newErr).some((v) => v);
    if (!hasError) {
      setIs_sub_but_dis(true);

      try {
        let path_encrypted = Encrypt_Value(form, "vozo");

        await axiosInstance.post("/vozo/need_help_send_email", path_encrypted);
        setModalAlerShow1(true);
        setForm((prev) => ({ ...prev, msg: "" }));
        setTimeout(() => {
          setIs_sub_but_dis(false);
          setModalAlerShow1(false);
          setModelPopup(false);
        }, 4000);
      } catch (error) {
        console.error("Error sending email:", error);
      }
    }
  };

  useEffect(() => {
    if (NavData1 !== "") {
      setNavData1(NavData1);
    }
  }, [NavData1]);
  // Memoize cards to prevent unnecessary recreations
  const cards = useMemo(
    () => [
      {
        title: "Basic Setup",
        items: [
          {
            id: "1.1",
            text: "Complete your personal & facility info",
            tooltip:
              "Provide essential information to ensure smooth performance.",
            completed: false,
            location: "/settings/settingsmyprofile",
            navigationType: "search",
          },
          {
            id: "2.1",
            text: "Setup your Users information",
            tooltip: "Add staff members to your practice.",
            completed: false,
            location: "/settings/Users",
            navigationType: "search",
          },
          {
            id: "3.1",
            text: "Manage your Service Codes",
            tooltip:
              "Input any custom procedures or products unique to your practice.",
            completed: false,
            location: "/settings/settingservice",
            navigationType: "data",
            state: { serbillgetstart1: true },
          },
          {
            id: "4.1",
            text: "Set Up Patient Portal Access",
            tooltip:
              "Enable the patient portal to allow patients to access appointments, and communication.",
            completed: false,
            location: "/settings/patientportal/all",
            navigationType: "state",
            state: { patientportalstarted: true },
          },
          {
            id: "5.1",
            text: "Add Custom Templates for Documentation",
            tooltip:
              "Create templates for assessments, and forms for documentation.",
            completed: true,
            location: "/settings/Templates",
            navigationType: "state",
            state: { showTemplatePopup: true },
          },
          {
            id: "6.1",
            text: "Add Patient & Schedule appointment",
            tooltip: "Add your first patient and schedule a visit.",
            completed: false,
            location: "/patient/patientlist",
            navigationType: "search",
          },
        ],
      },
      {
        title: "Front Office",
        items: [
          {
            id: "7",
            text: "Set your available office hours",
            tooltip:
              "Define the hours of your availability to ensure accurate scheduling.",
            completed: false,
            location: "/schedule/apptemplate",
            navigationType: "state",
            state: { Provstarted: true },
          },
          {
            id: "8",
            text: "Set Up User Permissions",
            tooltip: "Define user roles (e.g. admin, provider, staff etc).",
            completed: false,
            location: "/settings/Roles",
            navigationType: "state",
            state: { Rolesstarted: true },
          },
        ],
      },
      {
        title: "General",
        items: [
          {
            id: "9",
            text: "Add manual lab & its configuration details for lab orders",
            tooltip:
              "Configure local lab settings for seamless lab order processing.",
            completed: false,
            location: "/settings/lab",
            navigationType: "search",
          },
        ],
      },
      {
        title: "Integration",
        items: [
          {
            id: "10",
            text: "Setup Payment Gateway integration",
            tooltip: "Integrate with Stripe to process credit card payments.",
            completed: false,
            location: "/settings/settingbilling",
            navigationType: "state",
            state: {
              showBillingPopup: true,
              fromAccountSetup: true,
            },
          },
          {
            id: "11",
            text: "Setup your Clearance house",
            tooltip:
              "Set up Availity for claim submissions and insurance verifications.",
            completed: false,
            location: "/settings/settingbilling",
            navigationType: "state",
            state: {
              showBillingPopup: true,
              fromAccountSetupone: true,
              fromAccountSetup: false,
            },
          },
          {
            id: "12",
            text: "Setup Notification Integration Setting",
            tooltip: "Integrate Twilio for SMS reminders and communication.",
            completed: false,
            location: "/settings/notificationsettings",
            navigationType: "state",
            state: {
              fromAccountSetupnotification: true,
            },
          },
          {
            id: "13",
            text: "Create your H2H Digital To Account",
            tooltip:
              "Integrate Weno for e-prescriptions to streamline medication orders.",
            completed: false,
            location: "/settings/ERXsettings",
            navigationType: "state",
            state: {
              fromAccountSetuperx: true,
            },
          },
          // {
          //   id: "14",
          //   text: "Setup Lab Integration",
          //   tooltip: "Set up Health Gorilla for lab orders and results.",
          // navigationType: "state",
          // completed: false,
          // location: "/settings/lab-integration",
          // },
        ],
      },
      {
        title: "Billing",
        items: [
          {
            id: "15",
            text: "Set up insurance carrier",
            tooltip:
              "Input details of insurance carriers your practice works with.",
            completed: false,
            location: "/settings/payersearch",
            navigationType: "state",
            state: { payerstateopen: true },
          },
          {
            id: "16",
            text: "Submit your first insurance claim",
            tooltip:
              "Prepare and submit your first insurance claim through the system.",
            completed: false,
            location: "/billing/insuranceclaim",
            navigationType: "state",
            state: { insclaimopenfromaccount: true },
          },
          {
            id: "17",
            text: "Receive your first payment from patient payment",
            tooltip: "Set up patient payment and receive first payment.",
            completed: false,
            location: "/billing/patientpayment",
            navigationType: "state",
            state: { patientpaymentopen: true },
          },
          {
            id: "18",
            text: "Process your EOB & ERA payments",
            tooltip:
              "Process your EOB & ERA based payment based on insurance claims.",
            completed: false,
            location: "/billing/eob",
            navigationType: "state",
            state: { Eobstarted: true },
          },
        ],
      },
      {
        title: "Patient",
        items: [
          {
            id: "19",
            text: "Input patient's insurance details for claims",
            tooltip:
              "Enter patient insurance info to ensure accurate claim submissions.",
            completed: false,
            location: insuranceCoveragePath,
            navigationType: "search",
          },
          {
            id: "20",
            text: "Complete all of patient demographics details",
            tooltip:
              "Complete all required demographic fields in patient profiles.",
            completed: false,
            location: patientLocationPath1,
            navigationType: "search",
          },
          {
            id: "22",
            text: "Add the cards in the patient",
            tooltip:
              "Store patient card information securely for future transactions.",
            completed: false,
            location: patientLocationPath2,
            navigationType: "search",
          },
          {
            id: "21",
            text: "Check Eligibility Verification for Patients",
            tooltip:
              "Verify patients eligibility to check coverage for insurance claims.",
            completed: false,
            location: insuranceCoveragePath,
            navigationType: "search",
          },
        ],
      },
    ],
    [],
  );

  const [hoveredStep, setHoveredStep] = useState({
    cardIndex: null,
    stepIndex: null,
  });

  const handleGoToGetStarted = async (id, location, navigationType, state) => {
    dispatch(
      setReturnPath({
        path: "/settings/accountsetup",
        fromComponent: "ChecklistItem",
      }),
    );

    const navigationParams = {
      pathname: location,
      state: {
        ...(navigationType === "state" ? state : {}),
        fromAccountSetup: true,
      },
    };

    if (navigationType === "search") {
      navigationParams.search = `?step=${id}`;
    }

    if (navigationType === "data") {
      navigationParams.data = state;
    }
    await history.replace(navigationParams);
  };

  const fetchCompletedSteps = useCallback(async () => {
    try {
      const userId = getUserId();
      if (!userId) return [];

      const response = await axiosInstance.get(
        `/vozo/account-setup/get-steps?user_id=${userId}`,
      );
      const decryptedResponse = Decrypt_Value(response.data, "vozo");

      return decryptedResponse.map((item) =>
        item.intro_key.replace("account_setup_", ""),
      );
    } catch (error) {
      console.error("Error fetching completed steps:", error);
      return [];
    }
  }, []);

  const refreshCompletedSteps = useCallback(async () => {
    const steps = await fetchCompletedSteps();
    setCompletedSteps(steps);

    // Calculate progress
    const totalSteps = cards.reduce((sum, card) => sum + card.items.length, 0);
    const completedCount = steps.length;
    setProgress(Math.round((completedCount / totalSteps) * 100));
  }, [fetchCompletedSteps, cards]);

  const handleStepClick = async (cardIndex, stepIndex) => {
    const item = cards[cardIndex].items[stepIndex];
    if (item.location) {
      handleGoToGetStarted(
        item.id,
        item.location,
        item.navigationType,
        item.state,
      );
      await refreshCompletedSteps();
    }
  };

  // ================================
  // FRONTEND API
  // ================================

  const handleDemoToggle = async () => {
    setShowDemoModal(false);
    setDemoLoading(true);

    try {
      const payload = { user_id: user_ID };
      const encryptedPayload = Encrypt_Value(payload, "vozo");
      let response;

      if (demoEnabled) {
        response = await axiosInstance.post(
          "/vozo/accountsetup/removesamplepatientdata",
          encryptedPayload,
        );
      } else {
        response = await axiosInstance.post(
          "/vozo/accountsetup/loadsamplepatientdata",
          encryptedPayload,
        );
      }

      const decryptedResponse = Decrypt_Value(response.data, "vozo");

      if (decryptedResponse.status === "success") {
        setDemoEnabled((prev) => !prev);
      } else {
        alert(decryptedResponse.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDemoLoading(false);
    }
  };

  const checkDemoStatus = async () => {
    try {
      const payload = {
        user_id: user_ID,
      };

      const encryptedPayload = Encrypt_Value(payload, "vozo");

      const response = await axiosInstance.post(
        "/vozo/accountsetup/checksamplepatientdata",
        encryptedPayload,
      );

      const decryptedResponse = Decrypt_Value(response.data, "vozo");

      if (decryptedResponse.status === "success") {
        setDemoEnabled(Boolean(decryptedResponse.enabled));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    checkDemoStatus();
  }, []);

  useEffect(() => {
    let isMounted = true;

    const loadData = async () => {
      try {
        await refreshCompletedSteps();
      } catch (error) {
        console.error(error);
      }
    };

    loadData();

    return () => {
      isMounted = false;
    };
  }, [refreshCompletedSteps]);

  useEffect(() => {
    const fetchEmail = async () => {
      try {
        const response = await axiosInstance.get(
          "/vozo/doctor/email/search?id=" + user_ID,
        );
        let temp_role = Decrypt_Value(response.data, "vozo");
        if (temp_role.length > 0 && temp_role[0].email) {
          setForm((prev) => ({ ...prev, email: temp_role[0].email }));
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchEmail();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.style.overflow = "auto";
  }, [fetchCompletedSteps, cards]);

  useEffect(() => {
    let isMounted = true;

    const loadData = async () => {
      try {
        const steps = await fetchCompletedSteps();
        if (!isMounted) return;

        setCompletedSteps(steps);

        // Calculate progress
        const totalSteps = cards.reduce(
          (sum, card) => sum + card.items.length,
          0,
        );
        const completedCount = steps.length;
        setProgress(Math.round((completedCount / totalSteps) * 100));
      } catch (error) {
        console.error("Error loading account setup data:", error);
      }
    };

    loadData();

    return () => {
      isMounted = false;
    };
  }, [fetchCompletedSteps, cards]);

  // Check if a step is completed
  const isStepCompleted = useCallback(
    (stepId) => completedSteps.includes(stepId.toString()),
    [completedSteps],
  );

  return (
    <>
      {demoLoading && (
        <Loader overlayStyle={{ backgroundColor: "rgba(255, 255, 255, 0.65)" }} />
      )}
      <SideNav />
      <div
        id="demographics"
        className={
          (navData1 === "iconopen" && "right-block setting-right-nav p-r-13") ||
          (navData1 === "iconclose" && "right-block setting-right-nav1 p-r-13")
        }
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div className="w-100">
          <div className="appt-block-main schedule-comp1 sty-m-t-4 m-b-0-imp">
            <div className="tab_title_main">
              <div className="account-setup-header mb-4">
                <h1 className="prob-head-title tab_title_name1 MTop">
                  Account Setup
                </h1>
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                  <p className="instruction-text mb-2 mb-md-0">
                    Follow these interactive checklist to setup the most of your
                    application. Keep going!
                  </p>
                  <div className="help-link">
                    Need help?{" "}
                    <a
                      className="support-link"
                      onClick={() => setModelPopup(true)}
                    >
                      Contact our support team
                    </a>
                  </div>
                </div>
              </div>

              <div className="progress-container mb-5">
                <div className="progress-wrapper position-relative">
                  <div
                    className="progress"
                    style={{ height: "10px", borderRadius: "5px" }}
                  >
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: `${progress}%`, borderRadius: "5px" }}
                      aria-valuenow={progress}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                  <span
                    className="progress-percentage"
                    style={{
                      position: "absolute",
                      top: "15px",
                      left:
                        progress === 0
                          ? "1%"
                          : progress === 100
                            ? "99%"
                            : `${progress}%`,
                      transform: "translateX(-50%)",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {progress}%
                  </span>
                </div>
              </div>

              <div
                className="d-flex justify-content-start align-items-center flex-wrap mb-4"
                style={{
                  marginTop: "-8px",
                  gap: "4px",
                }}
              >
                <p
                  style={{
                    marginBottom: "0px",
                    fontSize: "14px",
                    color: "#5F6368",
                    lineHeight: "22px",
                  }}
                >
                  You can also check out the application using sample data for
                  some features which helps in better understanding of the
                  function.
                </p>

                <div
                  className="d-flex align-items-center"
                  style={{
                    gap: "10px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "14px",
                      fontWeight: "500",
                      color: "#5F6368",
                      whiteSpace: "nowrap",
                    }}
                  >
                    Load Sample Patient Data:
                  </span>

                  <Form.Check
                    type="switch"
                    id="sample-data-switch"
                    checked={demoEnabled}
                    onChange={() => setShowDemoModal(true)}
                    disabled={demoLoading}
                    style={{
                      marginBottom: "0px",
                    }}
                  />

                  {/*
                  <button
                    onClick={() => {
                      console.log("=== TEST BUTTON CLICKED ===");
                      console.log("Current demoEnabled:", demoEnabled);
                      setDemoEnabled(!demoEnabled);
                      console.log("Called setDemoEnabled to:", !demoEnabled);
                      setTimeout(() => {
                        console.log("demoEnabled after 500ms:", demoEnabled);
                      }, 500);
                    }}
                    style={{
                      fontSize: "12px",
                      padding: "4px 8px",
                      marginLeft: "10px",
                      background: "#007bff",
                      color: "white",
                      border: "none",
                      borderRadius: "4px",
                      cursor: "pointer",
                    }}
                  >
                    Test: {demoEnabled ? "ON" : "OFF"}
                  </button>
                  */}
                </div>
              </div>

              <div className="m-4">
                <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4 pe-4">
                  {cards.map((card, cardIndex) => {
                    const completedCount = card.items.filter((item) =>
                      isStepCompleted(item.id),
                    ).length;
                    const completionPercentage =
                      card.items.length > 0
                        ? (completedCount / card.items.length) * 100
                        : 0;

                    return (
                      <div
                        key={cardIndex}
                        style={{ breakInside: "avoid", marginBottom: "1rem" }}
                        className="col"
                      >
                        <div
                          className="card shadow-sm p-4"
                          style={{ height: "100%", padding: "1.5rem" }}
                        >
                          <div
                            style={{ gap: "16px", marginBottom: "12px" }}
                            className="d-flex align-items-center"
                          >
                            <div
                              className="d-flex align-items-center justify-content-center"
                              style={{
                                width: "55px",
                                height: "55px",
                                borderRadius: "50%",
                                background: `conic-gradient(#0d6efd ${completionPercentage}%, #e9ecef 0%)`,
                                position: "relative",
                                transition: "background 0.5s ease-in-out",
                              }}
                            >
                              <div
                                style={{
                                  width: "45px",
                                  height: "45px",
                                  borderRadius: "50%",
                                  background: "white",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  fontWeight: "bold",
                                  fontSize: "16px",
                                  color: "#2e2e2e",
                                }}
                              >
                                {completedCount}/{card.items.length}
                              </div>
                            </div>
                            <h5
                              className="mb-0"
                              style={{ fontWeight: "600", fontSize: "1.2rem" }}
                            >
                              {card.title}
                            </h5>
                          </div>

                          <div>
                            {card.items.map((item, stepIndex) => {
                              const isCompleted = isStepCompleted(item.id);

                              return (
                                <div
                                  key={item.id}
                                  className="d-flex align-items-start position-relative"
                                  style={{
                                    cursor: "pointer",
                                    paddingRight: "24px",
                                    marginBottom: "10px",
                                  }}
                                  onClick={() =>
                                    handleStepClick(cardIndex, stepIndex)
                                  }
                                >
                                  <div
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      borderRadius: "50%",
                                      marginRight: "14px",
                                      marginTop: "4px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      flexShrink: 0,
                                      border: isCompleted
                                        ? "none"
                                        : "2px solid #2E2E2E80",
                                      backgroundColor: isCompleted
                                        ? "transparent"
                                        : "white",
                                    }}
                                  >
                                    {isCompleted && (
                                      <img
                                        src={BlueTick}
                                        width={20}
                                        height={20}
                                      />
                                    )}
                                  </div>

                                  <span
                                    style={{
                                      textAlign: "left",
                                      width: "240px",
                                    }}
                                  >
                                    {item.text}
                                  </span>
                                  <div
                                    style={{
                                      position: "absolute",
                                      right: "0",
                                      top: "10px",
                                      transform: "translateY(-50%)",
                                    }}
                                  >
                                    <img
                                      src={icon}
                                      alt="info"
                                      style={{
                                        width: "18px",
                                        height: "18px",
                                        cursor: "pointer",
                                      }}
                                      onMouseEnter={() =>
                                        setHoveredStep({ cardIndex, stepIndex })
                                      }
                                      onMouseLeave={() =>
                                        setHoveredStep({
                                          cardIndex: null,
                                          stepIndex: null,
                                        })
                                      }
                                    />
                                    {hoveredStep.cardIndex === cardIndex &&
                                      hoveredStep.stepIndex === stepIndex && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            bottom: "100%",
                                            right: 0,
                                            width: "200px",
                                            backgroundColor: "#2E2E2E",
                                            color: "#FFFFFF",
                                            boxShadow:
                                              "0 2px 8px rgba(0,0,0,0.15)",
                                            padding: "10px",
                                            borderRadius: "4px",
                                            marginBottom: "8px",
                                            zIndex: 10,
                                            textAlign: "left",
                                          }}
                                          onMouseEnter={() =>
                                            setHoveredStep({
                                              cardIndex,
                                              stepIndex,
                                            })
                                          }
                                          onMouseLeave={() =>
                                            setHoveredStep({
                                              cardIndex: null,
                                              stepIndex: null,
                                            })
                                          }
                                        >
                                          <div
                                            style={{
                                              position: "absolute",
                                              bottom: "-5px",
                                              right: "5px",
                                              width: "0",
                                              height: "0",
                                              borderLeft:
                                                "5px solid transparent",
                                              borderRight:
                                                "5px solid transparent",
                                              borderTop: "5px solid #2E2E2E",
                                            }}
                                          />
                                          <p
                                            style={{
                                              margin: 0,
                                              fontSize: "12px",
                                            }}
                                          >
                                            {item.tooltip ||
                                              "More information about this step"}
                                          </p>
                                        </div>
                                      )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        centered
        show={modelPopup}
        onHide={() => {
          setForm((prev) => ({ ...prev, msg: "" }));
          setErrMsg((prev) => ({ ...prev, msg: false }));

          setModelPopup(false);
        }}
      >
        <div id="add-patientflag">
          <Modal.Header closeButton>
            <Modal.Title>Contact Us</Modal.Title>
          </Modal.Header>
          <Form className="add-contact-form" onSubmit={handleSubmit}>
            <Modal.Body>
              <Form.Row>
                <Form.Group as={Col}>
                  <Form.Label>
                    Name <span style={{ color: "#E23D28" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    name="name"
                    value={form.name}
                    onChange={handleFormChange}
                    autoComplete="off"
                    maxLength={20}
                    disabled={true}
                    style={
                      errMsg.name
                        ? { border: "1px solid red", borderRadius: "5px" }
                        : {}
                    }
                  />
                  {errMsg.name && (
                    <p className="errormessage" style={{ color: "red" }}>
                      Enter a valid name
                    </p>
                  )}
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <Form.Group as={Col}>
                  <Form.Label>
                    Email <span style={{ color: "#E23D28" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleFormChange}
                    autoComplete="off"
                    disabled={true}
                    style={
                      errMsg.email
                        ? { border: "1px solid red", borderRadius: "5px" }
                        : {}
                    }
                  />
                  {errMsg.email && (
                    <p className="errormessage" style={{ color: "red" }}>
                      Enter a valid email
                    </p>
                  )}
                </Form.Group>
              </Form.Row>

              <Form.Row>
                <Form.Group as={Col}>
                  <Form.Label>
                    Message <span style={{ color: "#E23D28" }}>*</span>
                  </Form.Label>
                  <Form.Control
                    className="msg-input-height"
                    as="textarea"
                    name="msg"
                    value={form.msg}
                    onChange={handleFormChange}
                    autoComplete="off"
                    style={
                      errMsg.msg
                        ? { border: "1px solid red", borderRadius: "5px" }
                        : {}
                    }
                  />
                  {errMsg.msg && (
                    <p className="errormessage" style={{ color: "red" }}>
                      Enter a valid message
                    </p>
                  )}
                </Form.Group>
              </Form.Row>
            </Modal.Body>
            <Modal.Footer>
              <Button
                className="need-help-but"
                variant="light"
                onClick={() => {
                  setModelPopup(false);
                  setForm((prev) => ({ ...prev, msg: "" }));
                  setErrMsg((prev) => ({ ...prev, msg: false }));
                }}
              >
                Close
              </Button>
              <Button
                className="need-help-but"
                type="submit"
                variant="primary"
                disabled={is_sub_but_dis}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Form>
        </div>
      </Modal>
      <Modal
        className="alert-popup-message"
        show={modalAlerShow1}
        onHide={() => setModalAlerShow1(false)}
      >
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" />
          Mail has been send successfully
        </div>
      </Modal>

      <Modal
        centered
        show={showDemoModal}
        onHide={() => setShowDemoModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {demoEnabled ? "Remove Sample Data" : "Load Sample Data"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p style={{ lineHeight: "26px", marginBottom: 0 }}>
            {demoEnabled
              ? "This will remove all sample patient records and related demo data from the application."
              : "This will create sample patients, appointments, billing records, medications, treatment plans and other demo workflows."}
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light" onClick={() => setShowDemoModal(false)}>
            Cancel
          </Button>

          <Button
            variant="primary"
            onClick={handleDemoToggle}
            disabled={demoLoading}
          >
            {demoLoading
              ? "Please Wait..."
              : demoEnabled
                ? "Remove"
                : "Load Data"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AccountSetup;
